import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  ApolloLink,
} from "@apollo/client";
import { onError } from "apollo-link-error";
import { forceLogout } from "./data/Axios/authInterceptor";

//const maziwa_baseurl = process.env.REACT_APP_BASE_URL;
// const maziwa_baseurl = "https://uat.api.sababisha.com";
export const maziwa_baseurl =
  process.env.REACT_APP_BASE_URL || "https://api.sababisha.com";
// "https://uat.api.sababisha.com";

const onErrorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, location, path }) => {
      console.error(`Graphql error ${message}`);
    });
  }
  if (networkError && networkError.statusCode === 401) {
    forceLogout();
  }
});

const AppConfig = {
  USER_MANAGEMENT_URL: new HttpLink({
    uri: `${maziwa_baseurl}/user`,
    // uri: "https://localhost:7131/graphql/",
  }),
  ROLE_MANAGEMENT_URL: new HttpLink({
    uri: `${maziwa_baseurl}/role`,
    //uri: "https://localhost:7052/graphql/",
  }),
};

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  if (!token) {
    console.error("Token not found in localStorage");
    return {};
  }

  const formattedToken = `Bearer ${token.replace(/"/g, "")}`;

  return {
    Authorization: formattedToken,
  };
};

// Middleware to add authorization headers
const authMiddleware = new ApolloLink((operation, forward) => {
  const headers = getAuthHeaders();
  if (headers.Authorization) {
    operation.setContext({
      headers: {
        ...headers,
      },
    });
  } else {
    console.warn("Authorization header is missing");
  }

  return forward(operation);
});

export const createUsersClient = () => {
  const userManagementHttpLink = new HttpLink({
    uri: `${maziwa_baseurl}/user`,
    //uri: "https://localhost:7131/graphql/",
  });
  const userHttpLinkWithAuth = authMiddleware.concat(userManagementHttpLink);

  return new ApolloClient({
    link: onErrorLink.concat(userHttpLinkWithAuth),
    cache: new InMemoryCache(),
  });
};

export const createRoleClient = () => {
  const roleManagementHttpLink = new HttpLink({
    uri: `${maziwa_baseurl}/role`,
    //uri: "https://localhost:7052/graphql/",
  });
  const roleHttpLinkWithAuth = authMiddleware.concat(roleManagementHttpLink);

  return new ApolloClient({
    link: onErrorLink.concat(roleHttpLinkWithAuth),
    cache: new InMemoryCache(),
  });
};

export const createSetupClient = () => {
  const setupManagementHttpLink = new HttpLink({
    uri: `${maziwa_baseurl}/setups`,
    // uri: "https://localhost:7266/graphql/",
  });
  const setupHttpLinkWithAuth = authMiddleware.concat(setupManagementHttpLink);

  return new ApolloClient({
    link: onErrorLink.concat(setupHttpLinkWithAuth),
    cache: new InMemoryCache(),
  });
};

export const createWalletClient = () => {
  const walletHttpLink = new HttpLink({
    //uri: "https://localhost:7100/graphql/",
    uri: `${maziwa_baseurl}/wallet`,
    //uri: "https://localhost:7280/graphql/",
  });
  const walletHttpLinkWithAuth = authMiddleware.concat(walletHttpLink);

  return new ApolloClient({
    link: onErrorLink.concat(walletHttpLinkWithAuth),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: { fetchPolicy: "network-only" },
      query: { fetchPolicy: "network-only" },
    },
  });
};
export default AppConfig;

export const loginUrl = {
  login: `${maziwa_baseurl}/user/login`,
  // login: "https://localhost:7131/Login",
  // login:"https://localhost:7091/login/"
};
export const roleManagemenUrl = {
  //uri: "https://localhost:7052/graphql/",
  uri: `${maziwa_baseurl}/role`,
};
export const PULL_TRANSACTIONS_URL = {
  uri: `${maziwa_baseurl}/QueryPullTransactions`,
};
export const REGISTER_PULL_URL = {
  uri: `${maziwa_baseurl}/RegisterPull`,
};
export const userManagementUrl = {
  uri: `${maziwa_baseurl}/user`,
  //uri: "https://localhost:7131/graphql/",
};
export const requestUnlocOTPUrl = {
  uri: `${maziwa_baseurl}/user/requestunlockotp`,
  // uri: "https://localhost:7131/graphql/",
};
export const verifyUnlocOTPUrl = {
  uri: `${maziwa_baseurl}/user/verifyunlockotp`,
  //uri: "https://localhost:7131/graphql/",
};

export const MCBSwitchService = {
  uri: `${maziwa_baseurl}/user/mcbswitch`,
  // uri: "https://localhost:7131/mcbswitch/",
};

export const companyManagementUrl = {
  uri: `${maziwa_baseurl}/company`,
  //uri: " https://localhost:7239/graphql/",
  upload_logo_uri: `${maziwa_baseurl}/company/uploadlogo`,
  upload_diylogo_uri: `${maziwa_baseurl}/company/uploadlogoDIY`,
  // uri:"https://localhost:7157/graphql/",
};

export const smsservice = {
  uri: `${maziwa_baseurl}/sms`,
  // uri: "https://localhost:7068/graphql/",
};
export const HRService = {
  uri: `${maziwa_baseurl}/hrservice`,
  //uri: "https://localhost:7138/graphql/"
  //HRService
};
export const salesManagement = {
  uri: `${maziwa_baseurl}/hrservice`,
  //uri: "https://localhost:7138/graphql/"
};
//customer
export const customerservice = {
  uri: `${maziwa_baseurl}/customer`,
  //uri: "https://localhost:7048/graphql/",
  statement: `${maziwa_baseurl}/customer/uploadstatement`,
  //statement: "http://localhost:5273/uploadStatement",
  generate_report_uri: `${maziwa_baseurl}/customer/viewreport`,
  generate_finsights_token_uri: `${maziwa_baseurl}/customer/GetFinsightsToken`,
  // generate_report_uri: "https://localhost:7048/viewReport",
  //statement: "https://localhost:7048/uploadStatement",
  statement_progress: `${maziwa_baseurl}/customer/GetStatementProgress`,
  // statement_progress: "https://localhost:7048/GetStatementProgress"
};
export const emailService = {
  uri: `${maziwa_baseurl}/email`,
};
export const RequestUnlockOTP = {
  uri: `${maziwa_baseurl}/user/requestunlockotp`,
  //uri: "https://localhost:7131/requestunlockotp",
};
export const VerifyUnlockOTP = {
  uri: `${maziwa_baseurl}/user/verifyunlockotp`,
  //uri: "https://localhost:7131/verifyunlockotp",
};
export const AccountsandFinanceurl = {
  uri: `${maziwa_baseurl}/account`,
  //uri: "https://localhost:7237/graphql/",
  upload_file_uri: `${maziwa_baseurl}/account/reconupload`,
  upload_sms_file_uri: `${maziwa_baseurl}/account/reconsmsupload`,
  // upload_file_uri:"https://localhost:7237/FileUpload/ReconUpload",
  // uri:"https://localhost:7157/graphql/",
};
export const ForgetPasswordApiService = {
  uri: `${maziwa_baseurl}/user/forgotpassword`,
};
export const setupManagementUrl = {
  uri: `${maziwa_baseurl}/setups`,
  //uri: "https://localhost:7210/graphql/",
};
export const inventoryManagementUrl = {
  uri: "https://opobe.mcb.co.ke/opogateway/opoinventory",
};
export const documentManagementUrl = {
  // uri: "https://localhost:7294/graphql",
  uri: `${maziwa_baseurl}/opodocumentmanagement`,
  baseFilePath:
    "https://opobe.mcb.co.ke/opogateway/opodocumentmanagement/ReadDocument?",
  // baseFilePath: "https://api.sheriapro.sababisha.com/gateway/documentmanagement/ReadDocumentNoSecurity?"
};

export const notificationservice = {
  //uri:"https://localhost:7057/graphql/",
  uri: `${maziwa_baseurl}/notification`,
};
export const notificationHubUrl = `${maziwa_baseurl}/hubs/notifications`;
export const loanManagementUrl = {
  // uri: "https://localhost:7113/graphql/",
  uri: `${maziwa_baseurl}/loan`,
};
export const AssetFinanceUrl = {
  // uri: "https://localhost:7297/graphql/",
  uri: `${maziwa_baseurl}/assetfinance`,
};
export const SDLSUrl = {
  uri: `${maziwa_baseurl}/sdls`,
};
export const getlogsUrl = {
  uri: `${maziwa_baseurl}/mpesa/getlogs`,
};
export const mpesaServiceUrls = {
  smsPay: `${maziwa_baseurl}/Mpesa/STKPushAttemptCompany`,
  //smsPay:'https://localhost:7260/Mpesa/STKPushAttempt'
  sababishaStatusCheck: `${maziwa_baseurl}/TriggerSababishaStatusCheck`,
  sababishaStatus: `${maziwa_baseurl}/SababishaStatus`,
  // sababishaStatusCheck:'https://localhost:7260/Mpesa/TriggerSababishaStatusCheck',
  // sababishaStatus:'https://localhost:7260/Mpesa/SababishaStatus'
  queryAccountBalance: `${maziwa_baseurl}/QueryAccountBalance`,
  accountBalanceStatus: `${maziwa_baseurl}/AccountBalanceStatus`,
  latestAccountBalance: `${maziwa_baseurl}/LatestAccountBalance`,
};
export const walletGraphqlUrl = {
  // uri: "https://localhost:7100/graphql/",s
  uri: `${maziwa_baseurl}/wallet`,
};
export const walletServiceUrls = {
  topUp: `${maziwa_baseurl}/mpesa/WalletTopUp`,
  topUpCallback: `${maziwa_baseurl}/WalletTopUpCallback`,
};
export const mpesaKycUrl = {
  validateMobileNumber: `${maziwa_baseurl}/Mpesa/ValidateMobileNumber`,
  //validateMobileNumber: 'https://localhost:7260/Mpesa/ValidateMobileNumber'
};
export const statementUploader = {
  uri: "https://api.finsights.sababisha.com/api/upload",
  //uri: "https://fsbe.mcb.co.ke/finsightsgateway/api/upload",
  bank_url: "https://api.finsights.sababisha.com/api/uploadBankStatement",
};
export const finsightsGatewayUrl = {
  reportManagement: "https://api.finsights.sababisha.com/ReportManagement",
};
export const finsightsSetupUrl = {
  setup: "https://api.finsights.sababisha.com/setupmanagement",
};

/** Default logo shown when no company logo has been uploaded yet.
 *  Change this one value to swap the fallback for the entire app. */
export const DEFAULT_LOGO =
  process.env.REACT_APP_DEFAULT_LOGO || "/SSLLOGO.jpg";

export const downloadsUrl = {
  file: `${maziwa_baseurl}/company/usermanual`,
  apk: `${maziwa_baseurl}/company/mobile`,
};
export const reportsManagementUrl = {
  uri: `${maziwa_baseurl}/reports`,
  // uri: "https://localhost:7056/graphql/",
  generate_report_uri: `${maziwa_baseurl}/OPOReports/generateReport`,
  // "http://127.0.0.1:5052/OPOReports/generateReport",
  engine_uri: `${maziwa_baseurl}/OPOReports/generateReport`,
  fs_engine_uri: `${maziwa_baseurl}/OPOReports/generateReport`,
  fs2_engine_uri: "Https://api.finsights.sababisha.com/api/generateFSReport",
};
